import * as React from "react";
import type { SVGProps } from "react";

const MembershipReady = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#050033"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 80C66.569 80 80 66.569 80 50C80 33.431 66.569 20 50 20C33.431 20 20 33.431 20 50C20 66.569 33.431 80 50 80ZM65.254 41.601C66.138 40.54 65.995 38.963 64.934 38.08C63.873 37.196 62.297 37.339 61.413 38.4L46.499 56.297L38.434 48.232C37.458 47.256 35.875 47.256 34.899 48.232C33.923 49.209 33.923 50.792 34.899 51.768L44.899 61.768C45.396 62.265 46.078 62.529 46.78 62.498C47.482 62.466 48.138 62.14 48.587 61.601L65.254 41.601Z"
    />
  </svg>
);

export default MembershipReady;
